module.exports = __webpack_public_path__ + "66d30d603494af84757fb8036e19981d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/af.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/af.svg
// module chunks = 0